import ConstTerms from '../../../helpers/ConstTerms';

const SubscApplyTermConst = {
  TERMS: [
    {id: 1, key: ConstTerms.SERVICE_AGREEMENT, showinfo: true, checked: false, required: true, label: ConstTerms.getTermsTitle()[ConstTerms.SERVICE_AGREEMENT]},
    {id: 2, key: ConstTerms.PERSONAL_INFO_AGREE, showinfo: true, checked: false, required: true, label: ConstTerms.getTermsTitle()[ConstTerms.PERSONAL_INFO_AGREE]},
    {id: 3, key: ConstTerms.MARKETING, showinfo: true, checked: false, required: false, label: ConstTerms.getTermsTitle()[ConstTerms.MARKETING]},
    {id: 4, key: ConstTerms.AD_RECEIVE_AGREE, showinfo: false, checked: false, required: false, label: ConstTerms.getTermsTitle()[ConstTerms.AD_RECEIVE_AGREE]},
  ],

  TERMS_AD_RECEIVE: [
    {id: 1, key:  ConstTerms.AD_RECEIVE_EMAIL, showinfo: false, checked: false, required: false, label: ConstTerms.getTermsTitle()[ConstTerms.AD_RECEIVE_EMAIL]},
    {id: 2, key:  ConstTerms.AD_RECEIVE_SMS, showinfo: false, checked: false, required: false, label: ConstTerms.getTermsTitle()[ConstTerms.AD_RECEIVE_SMS]},
    {id: 3, key:  ConstTerms.AD_RECEIVE_APP, showinfo: false, checked: false, required: false, label: ConstTerms.getTermsTitle()[ConstTerms.AD_RECEIVE_APP]},
  ],

  TERMS_INSURANCE: [
    {id: 1, key: ConstTerms.INSURANCE, showinfo: true, checked: false, required: true, label: ConstTerms.getTermsTitle()[ConstTerms.INSURANCE]},
    {id: 2, key: ConstTerms.INSURANCE_PERSONAL_INFO_AGREE, showinfo: true, checked: false, required: true, label: ConstTerms.getTermsTitle()[ConstTerms.INSURANCE_PERSONAL_INFO_AGREE]},
    // {id: 3, key: ConstTerms.INSURANCE_MARKETING, showinfo: true, checked: false, required: false, label: ConstTerms.getTermsTitle()[ConstTerms.INSURANCE_MARKETING]},
  ],

  TERMS_TRANSPER: [
    {id: 1, key: ConstTerms.ESCALATION, showinfo: true, checked: false, required: true, label: ConstTerms.getTermsTitle()[ConstTerms.ESCALATION]},
  ],
};


export default SubscApplyTermConst;